import { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/all";
import ContainerSliders from "./ContainerSliders/ContainerSliders";
gsap.registerPlugin(ScrollTrigger);

const ContainerDiv = styled.div`
  /* CORRECT */

  .slider {
    padding-right: 2.5rem;
  }
  .video-carousel_container {
    position: relative;
    width: 88vw;
    height: 72dvh;
  }

  .bg-cover {
    position: absolute;
    inset: 0px;
    background: linear-gradient(
      to bottom,
      rgb(0, 0, 0) 15%,
      transparent 50%,
      transparent 100%
    );
    z-index: 1;
    border-radius: 1.5rem;
  }

  .sub-container-video {
    border-radius: 1.5rem;
    height: 100%;
    overflow: hidden;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
    transform: translateY(10rem);
  }

  .container-player {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-slider {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    background: rgb(91 91 91);
    border-radius: 3rem;
    height: 5rem;
    padding: 0 2rem;
  }

  .span-btn {
    width: 1rem;
    height: 0.9rem;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2rem;
    overflow: hidden;
    border: none;
    cursor: pointer;
    position: relative;
  }

  .span-btn-hover {
    position: absolute;
    width: 100%;
    height: 0.9rem;
    border-radius: 2rem;
  }

  .control-btn {
    background: rgb(91 91 91);
    border-radius: 50%;
    height: 5rem;
    width: 5rem;
    margin-left: 1rem;
    padding: 1.3rem;
    backdrop-filter: blur(12px);
  }

  @media only screen and (min-width: 992px) {
    .slider {
      padding-right: 5rem;
    }

    .bg-cover {
      background: linear-gradient(
        to top,
        rgb(0, 0, 0) 15%,
        transparent 50%,
        transparent 100%
      );
    }

    video {
      transform: translateY(-8rem);
    }
  }
`;

const hightlightsSlides = [
  {
    _id: 1,
    card_heading: {
      section_id: "heading-slider-1",
      style_render: "992",
      main_container_css: "",
      container_mobile_styles: {
        position: "absolute",
        top: "3rem",
        left: "2rem",
        right: "2rem",
        "max-width": "70rem",
        margin: "0 auto",
        "z-index": "1",
      },
      container_desktop_styles: {
        position: "absolute",
        top: "inherit",
        bottom: "3rem",
        "max-width": "70rem",
        margin: "0 auto",
      },
      obj_heading: {
        main_text:
          "<span class='t-enlace'>Start</span> From Zero. No Partner Needed",
        main_tag_version: "h3",
        main_text_css: "t-h-3",
        heading_mobile_styles: {
          "text-align": "center",
          "margin-bottom": "0.5rem",
          "text-shadow":
            "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
        },
        heading_desktop_styles: {},
      },
      obj_support_heading: false,

      obj_divider: {
        divider_mobile_styles: {
          width: "100%",
          background:
            "linear-gradient(90deg, transparent, #e6c28b, transparent)",
          margin: "0 auto 1.5rem auto",
        },
        divider_desktop_styles: false,
      },
      obj_paragraph: {
        main_text:
          "Begin with beginner-friendly courses designed to be simple, clear, and easy to follow. No experience, no partner, no pressure, just a proven way to start and actually learn",
        main_tag_version: "p",
        main_text_css: "",
        paragraph_mobile_styles: {
          "text-align": "center",
          "text-shadow":
            "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
        },
        paragraph_desktop_styles: false,
      },
      obj_buttons: false,
      heading_version: "heading_01",
    },

    card_content: {
      type: "video",
      videoDuration: 7,
      src_content:
        "https://res.cloudinary.com/djiqf3usa/video/upload/v1769553693/Clients/LTMastery/Frontpage/Videos/start-sensual-bachata-from-zero-no-partner-required_u4z5b1.mov",
      alt_content: "",
    },

    version: "slider_card_01",
  },
  {
    _id: 2,
    card_heading: {
      section_id: "heading-slider-2",
      style_render: "992",
      main_container_css: "",
      container_mobile_styles: {
        position: "absolute",
        top: "3rem",
        left: "2rem",
        right: "2rem",
        "max-width": "70rem",
        margin: "0 auto",
        "z-index": "1",
      },
      container_desktop_styles: {
        position: "absolute",
        top: "inherit",
        bottom: "3rem",
        "max-width": "70rem",
        margin: "0 auto",
      },
      obj_heading: {
        main_text: "<span class='t-enlace'>Structured</span> Learning Path",
        main_tag_version: "h3",
        main_text_css: "t-h-3",
        heading_mobile_styles: {
          "text-align": "center",
          "margin-bottom": "0.5rem",
          "text-shadow":
            "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
        },
        heading_desktop_styles: {},
      },
      obj_support_heading: false,

      obj_divider: {
        divider_mobile_styles: {
          width: "100%",
          background:
            "linear-gradient(90deg, transparent, #e6c28b, transparent)",
          margin: "0 auto 1.5rem auto",
        },
        divider_desktop_styles: false,
      },
      obj_paragraph: {
        main_text:
          "See exactly what to train, when to train it, and how everything connects. No guessing. No random videos. Just a clear path forward.",
        main_tag_version: "p",
        main_text_css: "",
        paragraph_mobile_styles: {
          "text-align": "center",
          "text-shadow":
            "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
        },
        paragraph_desktop_styles: false,
      },
      obj_buttons: false,
      heading_version: "heading_01",
    },

    card_content: {
      type: "video",
      videoDuration: 10,
      src_content:
        "https://res.cloudinary.com/djiqf3usa/video/upload/v1770419826/Clients/LTMastery/Frontpage/Videos/structured-sensual-bachata-training-system-dashboard_sozvwt.mp4",
      alt_content: "",
    },
    version: "slider_card_01",
  },
  {
    _id: 3,
    card_heading: {
      section_id: "heading-slider-3",
      style_render: "992",
      main_container_css: "",
      container_mobile_styles: {
        position: "absolute",
        top: "3rem",
        left: "2rem",
        right: "2rem",
        "max-width": "70rem",
        margin: "0 auto",
        "z-index": "1",
      },
      container_desktop_styles: {
        position: "absolute",
        top: "inherit",
        bottom: "3rem",
        "max-width": "70rem",
        margin: "0 auto",
      },
      obj_heading: {
        main_text: "<span class='t-enlace'>Train</span> Beyond the Basics",
        main_tag_version: "h3",
        main_text_css: "t-h-3",
        heading_mobile_styles: {
          "text-align": "center",
          "margin-bottom": "0.5rem",
          "text-shadow":
            "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
        },
        heading_desktop_styles: {},
      },
      obj_support_heading: false,

      obj_divider: {
        divider_mobile_styles: {
          width: "100%",
          background:
            "linear-gradient(90deg, transparent, #e6c28b, transparent)",
          margin: "0 auto 1.5rem auto",
        },
        divider_desktop_styles: false,
      },
      obj_paragraph: {
        main_text:
          "Go deeper with advanced courses focused on social technique, challenges, styling, and choreography, solo or in teams for dancers who want to level up",
        main_tag_version: "p",
        main_text_css: "",
        paragraph_mobile_styles: {
          "text-align": "center",
          "text-shadow":
            "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
        },
        paragraph_desktop_styles: false,
      },
      obj_buttons: false,
      heading_version: "heading_01",
    },

    card_content: {
      type: "video",
      videoDuration: 4,
      src_content:
        "https://res.cloudinary.com/djiqf3usa/video/upload/v1769553701/Clients/LTMastery/Frontpage/Videos/sensual-bachata-training-beyond-the-basics-advanced_ajlbkm.mov",
      alt_content: "",
    },
    version: "slider_card_01",
  },
  {
    _id: 4,
    card_heading: {
      section_id: "heading-slider-4",
      style_render: "992",
      main_container_css: "",
      container_mobile_styles: {
        position: "absolute",
        top: "3rem",
        left: "2rem",
        right: "2rem",
        "max-width": "70rem",
        margin: "0 auto",
        "z-index": "1",
      },
      container_desktop_styles: {
        position: "absolute",
        top: "inherit",
        bottom: "3rem",
        "max-width": "70rem",
        margin: "0 auto",
      },
      obj_heading: {
        main_text: "<span class='t-enlace'>Progress</span> You Can Feel",
        main_tag_version: "h3",
        main_text_css: "t-h-3",
        heading_mobile_styles: {
          "text-align": "center",
          "margin-bottom": "0.5rem",
          "text-shadow":
            "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
        },
        heading_desktop_styles: {},
      },
      obj_support_heading: false,

      obj_divider: {
        divider_mobile_styles: {
          width: "100%",
          background:
            "linear-gradient(90deg, transparent, #e6c28b, transparent)",
          margin: "0 auto 1.5rem auto",
        },
        divider_desktop_styles: false,
      },
      obj_paragraph: {
        main_text:
          "Train with Luis & Tay and experience real progress over time in your movement, confidence, and connection on and off the dance floor.",
        main_tag_version: "p",
        main_text_css: "",
        paragraph_mobile_styles: {
          "text-align": "center",
          "text-shadow":
            "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
        },
        paragraph_desktop_styles: false,
      },
      obj_buttons: false,
      heading_version: "heading_01",
    },

    card_content: {
      type: "video",
      videoDuration: 4,
      src_content:
        "https://res.cloudinary.com/djiqf3usa/video/upload/v1769553693/Clients/LTMastery/Frontpage/Videos/start-sensual-bachata-from-zero-no-partner-required_u4z5b1.mov",
      alt_content: "",
    },
    version: "slider_card_01",
  },
];

const VideoCarousel = () => {
  const videoRef = useRef([]);
  const videoSpanRef = useRef([]);
  const videoDivRef = useRef([]);

  // video and indicator
  const [video, setVideo] = useState({
    isEnd: false,
    startPlay: false,
    videoId: 0,
    isLastVideo: false,
    isPlaying: false,
  });

  const [loadedData, setLoadedData] = useState([]);
  const { isEnd, isLastVideo, startPlay, videoId, isPlaying } = video;

  useGSAP(() => {
    // slider animation to move the video out of the screen and bring the next video in
    gsap.to(".slider", {
      transform: `translateX(${-100 * videoId}%)`,
      duration: 2,
      ease: "power2.inOut", // show visualizer https://gsap.com/docs/v3/Eases
    });

    // video animation to play the video when it is in the view
    gsap.to("#heading-slider-1", {
      scrollTrigger: {
        trigger: "#heading-slider-1",
        toggleActions: "restart none none none",
      },
      onComplete: () => {
        setVideo((pre) => ({
          ...pre,
          startPlay: true,
          isPlaying: true,
        }));
      },
    });
  }, [isEnd, videoId]);

  useEffect(() => {
    let currentProgress = 0;
    let span = videoSpanRef.current;

    if (span[videoId]) {
      // animation to move the indicator
      let anim = gsap.to(span[videoId], {
        onUpdate: () => {
          // get the progress of the video
          const progress = Math.ceil(anim.progress() * 100);

          if (progress !== currentProgress) {
            currentProgress = progress;

            // set the width of the progress bar
            gsap.to(videoDivRef.current[videoId], {
              width:
                window.innerWidth < 760
                  ? "10vw" // mobile
                  : window.innerWidth < 1200
                  ? "10vw" // tablet
                  : "4vw", // laptop
            });

            // set the background color of the progress bar
            gsap.to(span[videoId], {
              width: `${currentProgress}%`,
              backgroundColor: "rgba(218, 218, 218, 1)",
            });
          }
        },

        // when the video is ended, replace the progress bar with the indicator and change the background color
        onComplete: () => {
          if (isPlaying) {
            gsap.to(videoDivRef.current[videoId], {
              width: "12px",
            });
            gsap.to(span[videoId], {
              backgroundColor: "#afafaf",
            });
          }
        },
      });

      if (videoId === 0) {
        anim.restart();
      }

      // update the progress bar
      const animUpdate = () => {
        anim.progress(
          videoRef.current[videoId].currentTime /
            hightlightsSlides[videoId]?.card_content?.videoDuration
        );
      };

      if (isPlaying) {
        // ticker to update the progress bar
        gsap.ticker.add(animUpdate);
      } else {
        // remove the ticker when the video is paused (progress bar is stopped)
        gsap.ticker.remove(animUpdate);
      }
    }
    // eslint-disable-next-line
  }, [videoId, startPlay]);

  useEffect(() => {
    if (loadedData.length > 3) {
      if (!isPlaying) {
        videoRef.current[videoId].pause();
      } else {
        startPlay && videoRef.current[videoId].play();
      }
    }
  }, [startPlay, videoId, isPlaying, loadedData]);

  // vd id is the id for every video until id becomes number 3
  const handleProcess = (type, i) => {
    switch (type) {
      case "video-end":
        setVideo((pre) => ({ ...pre, isEnd: true, videoId: i + 1 }));
        break;

      case "video-last":
        setVideo((pre) => ({ ...pre, isLastVideo: true }));
        break;

      case "video-reset":
        setVideo((pre) => ({ ...pre, videoId: 0, isLastVideo: false }));
        break;

      case "pause":
        setVideo((pre) => ({ ...pre, isPlaying: !pre.isPlaying }));
        break;

      case "play":
        setVideo((pre) => ({ ...pre, isPlaying: !pre.isPlaying }));
        break;

      default:
        return video;
    }
  };

  const handleLoadedMetaData = (i, e) => setLoadedData((pre) => [...pre, e]);

  return (
    <ContainerDiv id="video">
      <div className="t-flex-ac t-mb-4">
        {hightlightsSlides.map((info, index) => (
          <ContainerSliders
            key={info?._id}
            options={{
              objinfo: info,
              index,
              videoRef,
              handleProcess,
              setVideo,
              handleLoadedMetaData,
            }}
          />
        ))}
      </div>

      <div className="container-player">
        <div className="btn-slider">
          {videoRef.current.map((_, i) => (
            <span
              key={i}
              className="span-btn"
              ref={(el) => (videoDivRef.current[i] = el)}
            >
              <span
                className="span-btn-hover"
                ref={(el) => (videoSpanRef.current[i] = el)}
              />
            </span>
          ))}
        </div>

        <button className="control-btn">
          <img
            src={
              isLastVideo
                ? "/assets/images/replay.svg"
                : !isPlaying
                ? "/assets/images/play.svg"
                : "/assets/images/pause.svg"
            }
            alt={isLastVideo ? "replay" : !isPlaying ? "play" : "pause"}
            onClick={
              isLastVideo
                ? () => handleProcess("video-reset")
                : !isPlaying
                ? () => handleProcess("play")
                : () => handleProcess("pause")
            }
          />
        </button>
      </div>
    </ContainerDiv>
  );
};

export default VideoCarousel;
